export default __webpack_public_path__ + "static/media/photo--lg--89.22de9790.jpg";